

















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class SuccessSolid extends Vue {
  @Prop({ default: '48' }) readonly width?: string;
  @Prop({ default: '48' }) readonly height?: string;
  @Prop({ default: '#5BBD9E' }) readonly fill?: string;
  @Prop({ default: '#5BBD9E' }) readonly stroke?: string;
}
